import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import ErrorPage from "../ErrorMessage/ErrorPage";

const PrivateRoute = () => {
  // Check if user is authenticated
  const isAuthenticated = !!localStorage.getItem("response");

  // Redux: employee info and user search states
  const employeeInfo = useSelector((state) => state?.auth?.employeeInfo) || {};
  const isSearchUserError =
    useSelector((state) => state?.auth?.isSearchUserError) || false;
  const isSearchUserLoading =
    useSelector((state) => state?.auth?.isSearchUserLoading) || false;

  const location = useLocation();

  // Not authenticated -> redirect to login (preserve intended path), but avoid loop
  if (!isAuthenticated) {
    if (location.pathname === "/login") {
      // Already on login, don't redirect again
      return <Outlet />;
    }
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Authenticated and employee info ready -> render protected children
  if (employeeInfo?.adUpn) {
    return <Outlet />;
  }

  // Error fetching user -> error page
  if (isSearchUserError) {
    return <ErrorPage />;
  }

  // Still loading -> spinner
  if (isSearchUserLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "50vh",
          flexDirection: "column",
        }}
      >
        <CircularProgress color="primary" size={30} />
        <h2 className="mt-10">Searching User</h2>
      </div>
    );
  }

  // Default: render nothing (same as your v5 behavior)
  return null;
};

export default PrivateRoute;
